import {styled} from "@mui/material/styles";
import {Button} from "@mui/material";

export default styled(Button)({
  marginLeft: "2rem",
  marginRight: "2rem"
})
